import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, getTopBetsService } from 'games/BalloonGame/balloonPumpGame.service'

export const getMyBets = createAsyncThunk('pump-balloon-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getTopBets = createAsyncThunk('pump-balloon-game/topBets', async (params, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
